export default __webpack_public_path__ + "static/media/Home_Automation.d26a12e5.webp";